<button
    type="button"
    class="sidebar-account-trigger"
    #accountMenuTrigger="matMenuTrigger"
    [matMenuTriggerFor]="accountMenu"
    aria-label="Account menu"
    matTooltip="Account"
    matTooltipPosition="right">
    <span class="sidebar-account-avatar" [attr.aria-hidden]="true">
        @if (avatarUrl) {
            <img class="sidebar-account-avatar-image" [src]="avatarUrl" alt="" />
        } @else {
            <span class="sidebar-account-avatar-initials">{{ initials }}</span>
        }
    </span>
    <span class="sidebar-account-meta">
        <span class="sidebar-account-name" [title]="displayName">{{ displayName }}</span>
        <span class="sidebar-account-subtitle" [title]="subtitle">{{ subtitle }}</span>
    </span>
    <mat-icon
        class="icon-size-5 sidebar-account-more"
        [svgIcon]="'heroicons_outline:ellipsis-horizontal'"></mat-icon>
</button>

<div class="sidebar-account-version">BizCare v{{ appVersion }}</div>

<mat-menu
    #accountMenu="matMenu"
    class="sidebar-account-menu"
    xPosition="before"
    yPosition="above"
    [overlapTrigger]="false">
    <div class="sidebar-account-panel" (click)="$event.stopPropagation()">
        <company-switcher [embedded]="true"></company-switcher>
        <primary-color-picker></primary-color-picker>
        <button
            type="button"
            class="sidebar-account-action"
            (click)="toggleScheme()">
            <mat-icon
                class="icon-size-5 sidebar-account-action-icon"
                [svgIcon]="isDark ? 'heroicons_solid:moon' : 'heroicons_solid:sun'"></mat-icon>
            <span>{{ isDark ? 'Light mode' : 'Dark mode' }}</span>
        </button>
        <button
            type="button"
            class="sidebar-account-action"
            (click)="hardRefresh()">
            <mat-icon
                class="icon-size-5 sidebar-account-action-icon"
                [svgIcon]="'heroicons_outline:arrow-path'"></mat-icon>
            <span>Reload latest version</span>
        </button>
        <app-install-button variant="menu"></app-install-button>
        @if (canAccessPos) {
            <button
                type="button"
                class="sidebar-account-action"
                (click)="openPos()">
                <mat-icon
                    class="icon-size-5 sidebar-account-action-icon"
                    [svgIcon]="'heroicons_outline:shopping-cart'"></mat-icon>
                <span>POS</span>
            </button>
        }
        <div class="sidebar-account-divider"></div>
        <user [embedded]="true"></user>
    </div>
</mat-menu>
